import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { BASE_URL } from "api_urls";
import { usePrettyUrl } from "helpers/hooks/usePrettyUrl";

export const OloPassThroughParameters = [
  "ft",
  "table_id",
  "table_name",
] as const;

export const useOloUrl = () => {
  const storePrettyUrl = usePrettyUrl();
  const [searchParams] = useSearchParams();
  return useMemo(() => {
    const url = new URL(`${BASE_URL}/s/${storePrettyUrl}`);
    [...searchParams.entries()].forEach(([key, value]) => {
      if ((OloPassThroughParameters as readonly string[]).includes(key)) {
        url.searchParams.set(key, value);
      }
    });
    return url;
  }, [searchParams, storePrettyUrl]);
};
